import React, { useState } from 'react';
import { PlayCircle } from 'lucide-react';
import VideoModal from './VideoModal';

// "Ver tutorial" button that opens the matching /videos/<video> file in a
// full-screen modal. `video` is the filename under frontend/public/videos/.
const TutorialVideoButton = ({ video, caption, className = '' }) => {
  const [open, setOpen] = useState(false);
  const src = `/videos/${encodeURIComponent(video)}`;

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        data-testid="tutorial-video-button"
        className={`flex items-center gap-2 text-sm font-medium px-3 py-2 rounded-lg border border-border bg-card/60 hover:bg-card text-foreground transition-colors shrink-0 ${className}`}
      >
        <PlayCircle className="w-4 h-4" />
        Ver tutorial
      </button>

      {open && (
        <VideoModal src={src} onClose={() => setOpen(false)} caption={caption} />
      )}
    </>
  );
};

export default TutorialVideoButton;
